import * as React from "react";

import styles from "./NewCheckbox.module.css";

export interface NewCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: React.ReactNode;
  disabled?: boolean;
  className?: string;
}

//Новый компонент чекбокса, который должен переиспользоваться во всем приложении
export const NewCheckbox: React.FC<NewCheckboxProps> = ({ checked, onChange, label, disabled, className }) => (
  <label className={`${styles.root}${disabled ? ` ${styles.disabled}` : ``}${className ? ` ${className}` : ``}`}>
    <span
      className={`${styles.box}${checked ? ` ${styles.checked}` : ``}`}
      onClick={(e) => {
        e.preventDefault();
        if (!disabled) onChange(!checked);
      }}
    >
      {checked && <i className="fa-solid fa-check" />}
    </span>
    {label && (
      <span
        className={styles.label}
        onClick={(e) => {
          e.preventDefault();
          if (!disabled) onChange(!checked);
        }}
      >
        {label}
      </span>
    )}
  </label>
);
